import styled from 'styled-components';
import { consumerTheme } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body, H5 } from 'syf-component-library/ui/typography';
import query from 'syf-component-library/const/mediaQueries';
import colors from '../../../../../const/colors';
export const CurrentDateWrapper = styled(Inset) `
  margin: 0;
  text-align: center;
  color: ${consumerTheme.button.primary.hover};
  background-color: ${colors.turquoise};
  @media ${query.lessThanSmall} {
    border-radius: 5px;
  }
`;
export const Title = styled(Body) `
  font-size: 14px;
  text-transform: uppercase;
`;
export const DueDate = styled(H5) `
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
`;
